import { render } from "./MathAnwerFormButton.vue?vue&type=template&id=fcd5f1d6&ts=true"
import script from "./MathAnwerFormButton.vue?vue&type=script&lang=ts"
export * from "./MathAnwerFormButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__